import {Component, Input, OnInit, ViewContainerRef} from '@angular/core';
import {MatDialog, MatDialogConfig, MatDialogRef} from '@angular/material/dialog';
import {selectCanEditSegment} from '../../../user/user.reducer';
import {SegmentEditComponent} from './edit.component';
import {Observable} from 'rxjs';
import {Store} from '@ngrx/store';
import {first} from 'rxjs/operators';
import {ApiVersion} from '../../../app.types';
import {SegmentCreationData} from '../create/create.component';

// TODO: completely useless component that obfuscates responsibilities, refactor and delete
@Component({
  selector: 'app-segment-edit-button',
  template: `
    <button *ngIf="isAllowed$ | async"
            mat-icon-button
            name="button-segment-info-edit"
            id="button-segment-info-edit"
            data-cy="button-segment-info-edit"
            (click)="showDialog()">
      <mat-icon>edit</mat-icon>
    </button>
  `
})
export class SegmentEditButtonComponent implements OnInit {

  @Input() apiVersion: ApiVersion = ApiVersion.V1;
  isAllowed$: Observable<boolean> = this.store.select(selectCanEditSegment);
  dialogRef!: MatDialogRef<SegmentEditComponent> | null;
  private config!: MatDialogConfig;

  constructor(private store: Store,
              private viewContainerRef: ViewContainerRef,
              private dialog: MatDialog) {
  }

  ngOnInit(): void {
    this.config = new MatDialogConfig();
    this.config.viewContainerRef = this.viewContainerRef;
  }


  showDialog() {
    this.dialogRef = this.dialog.open(SegmentEditComponent, {
      ...this.config,
      data: <SegmentCreationData>{apiVersion: this.apiVersion}
    });
    this.dialogRef.afterClosed()
      .pipe(first())
      .subscribe(() => {
        this.dialogRef = null;
      });
  }

}
